import { render, staticRenderFns } from "./ReturnPartsListView.vue?vue&type=template&id=499560c5"
import script from "./ReturnPartsListView.vue?vue&type=script&lang=js"
export * from "./ReturnPartsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports